import { render, staticRenderFns } from "./appel.vue?vue&type=template&id=56f6e0ce"
import script from "./appel.vue?vue&type=script&lang=js"
export * from "./appel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports